import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import AddButton from "../../components/AddButton";
import DataTable from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import Loading from "../../components/loading";
import {deleteUser, fetchDataUser} from "../../services/userService";
import {Context} from "../../context/SearchContext";
import {useContext} from "react";
import SearchInput from "../../components/search/SearchInput";
import {toast} from "react-toastify";

const headerTable = [
    "id",
    "table.user.full_name",
    "table.user.username",
    "table.user.phone",
    "table.user.role",
    <span className="sr-only">Edit</span>,
];

const bodyTable = ["id", "fullName", "username", "phone", "role", "actions"];

const User = ({t}) => {
    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [forcePage, setForcePage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const ctx = useContext(Context);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const onDeleteItem = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            const response = await deleteUser(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/user/${id}`,
                token
            );
            if (response.success) {
                setIsLoading(false);
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                setIsLoading(false);
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    const fetchData = async () => {
        const response = await fetchDataUser(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/user/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [],
                search: {value: ctx.state, regex: true},
                filter: {},
            }
        );
        // console.log((response))
        if (response.success) {
            setIsLoading(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    ...item,
                    actions: (
                        <>
                            <EditButton
                                onclick={() => navigate(`/user/update/${item.id}`)}
                            />
                            <DeleteButton onclick={() => onDeleteItem(item.id)}/>
                        </>
                    ),
                };
            });

            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, ctx.state]);

    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <div className="px-4 py-4 sm:px-6 lg:px-8">
                    <div className="mb-2 sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                            <h1 className="text-xl font-semibold text-gray-900">
                                {t(`table.user.user_table`)}
                            </h1>
                        </div>
                        <AddButton title={t(`table.user.add_user`)} url={"add"}/>
                    </div>

                    <div>
                        <div className="flex justify-between items-center">
                            <Select
                                setItemsPerPage={setItemsPerPage}
                                itemsPerPage={itemsPerPage}
                            />
                            <SearchInput/>
                        </div>
                        <DataTable
                            data={data.data}
                            headerTable={headerTable}
                            bodyContent={bodyTable}
                        />
                        <Pagination
                            handlePageClick={handlePageClick}
                            pageCount={data.pageCount}
                            forcePage={forcePage}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default withTranslation()(User);
